import { useMemo } from "react";

import { useListPublicProtectionProfilesQuery } from "api/public/protectionProfiles/protectionProfiles.api";
import { PublicProtectionProfileFilters } from "api/public/protectionProfiles/protectionProfiles.types";

import { filterPps } from "../utils/filterPps";

export const useFilteredPps = (filters: PublicProtectionProfileFilters) => {
  const { data: allPps = [], isLoading } =
    useListPublicProtectionProfilesQuery();

  const protectionProfiles = useMemo(() => {
    if (!allPps.length) return [];
    if (!filters) return allPps;
    return filterPps(allPps, filters);
  }, [allPps, filters]);

  return { protectionProfiles, isLoading };
};
